import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, combineLatest, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {UserService} from './user.service';
import { environment } from '../../environments/environment';
import { AbstractHttpService } from './abstract-http-service';
import {IpopConfiguration} from '../model/ipop-configuration.model';

const siteWideUnlockFeatureName = 'siteWideUnlock';

@Injectable({
  providedIn: 'root'
})
export class IpopConfigurationService extends AbstractHttpService {
  defaultOptions = {
    headers: this.contentTypeJsonHeaders,
    withCredentials: true
  };

  constructor(private httpClient: HttpClient, private userService: UserService)
  {
    super();
  }

  getSettings(accountId: number): Observable<IpopConfiguration>
  {
    const settingsRequest = this.httpClient.get<IpopConfiguration>(
      `//${environment.autoDomain}:${environment.autoPort}/api/ipop-configuration/${accountId}`,
      this.defaultOptions
    );
    const request = combineLatest([settingsRequest, this.isSiteWideUnlockEnabled()]).pipe(
      map(([settings, enabled]) => ({
        ...settings,
        canConfigureSiteWideUnlock: enabled && settings.canConfigureSiteWideUnlock === true
      })),
      catchError(this.handleError)
    );

    return request;
  }

  private isSiteWideUnlockEnabled(): Observable<boolean>
  {
    const request = this.userService.getMpopFeature(siteWideUnlockFeatureName).pipe(
      map(features => features.some(feature => feature.name === siteWideUnlockFeatureName && feature.enabled === true)),
      catchError((error: unknown) => {
        console.warn('Sitewide Unlock is unavailable because its feature flag could not be loaded.', error);

        return of(false);
      })
    );

    return request;
  }

  updateSettings(settings: IpopConfiguration): Observable<unknown>
  {
    const request = this.httpClient.put(
      `//${environment.autoDomain}:${environment.autoPort}/api/ipop-configuration`,
      settings,
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );

    return request;
  }
}
